export default __webpack_public_path__ + "static/media/account-selected.d17fed72.svg";